import { jsx as _jsx } from "react/jsx-runtime";
import { MapTo, ResponsiveGrid } from "@adobe/aem-react-editable-components";
import classNames from "classnames";
import { convertHeroData, useStringPlaceholder } from "@jti/loyalty";
import { useSelector } from "@jti/store";
import { HeroV2, Loading } from "@jti/ui";
import { withAemAuthoring } from "../../app-related/withAemAuthoring";
import { processLoggedTitle } from "../heroV2/util/processLoggedTitle";
const heroV2EditConfig = {
    emptyLabel: "Hero V2 Container",
    isEmpty: () => false,
    getProps: ({ heroComponents, isInEditor, cqPath, fullWidthHeroOnTop }) => ({
        heroComponents,
        isInEditor,
        cqPath,
        fullWidthHeroOnTop,
    }),
};
export const HeroV2Container = (props) => {
    const replaceStringPlaceholderRunner = useStringPlaceholder();
    const { fullWidthHeroOnTop } = props;
    const { isRestricted, points: { status }, } = useSelector((store) => store.loyaltyCore);
    if (props.isInEditor) {
        // Those eslint and typescript rules are needed since @adobe/aem-react-editable-components cannot override component behavior like regular AEM components do
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        return _jsx(ResponsiveGrid, { pagePath: props.cqPath + "/heroComponents" });
    }
    const newProps = props.heroComponents.map((heroComponent) => {
        const { title, text, ctas } = convertHeroData(isRestricted, heroComponent);
        const { processedTitle, isLoading } = processLoggedTitle(status, replaceStringPlaceholderRunner, title);
        return {
            ...heroComponent,
            content: {
                ...heroComponent.content,
                titleLogged: isLoading ? _jsx(Loading, { whiteDots: true }) : processedTitle,
                textLogged: text,
                cta: ctas,
            },
            isViewportHeight: !!fullWidthHeroOnTop,
            isContainerWidth: !fullWidthHeroOnTop,
            removeVideoRoundedCorners: true,
        };
    });
    return (_jsx("div", { className: classNames({ ["aem-hero__base"]: fullWidthHeroOnTop }), children: _jsx(HeroV2, { data: newProps, isViewportHeight: !!fullWidthHeroOnTop, isContainerWidth: !fullWidthHeroOnTop }) }));
};
export default MapTo("loyalty/components/heroV2container")(withAemAuthoring(HeroV2Container, heroV2EditConfig));
